import React from "react";
import { Button, useTheme } from "@mui/material";

const SeasonRegistrationButton = ({ label = "Inscrição Época", onClick, disabled = false }) => {

    const theme = useTheme();
    return (
        <Button
            variant="contained"
            color="maize"
            size="small"
            disabled={disabled}
            type="button"
            onClick={onClick}
            sx={{ fontWeight: "bold" }}
        >
            {label}
        </Button>
    );
}

export default SeasonRegistrationButton;
